import React from "react";

// eslint-disable-next-line no-restricted-imports
import { Search, SearchProps } from "@packages/ds";

import { trackEventPendo, createUIAnalyticsEvent } from "Libs/analytics";

interface TrackedSearchProps extends Omit<SearchProps, "onChange"> {
  analyticId?: string;
  onChange?: (value: string) => void;
}

export const TrackedSearch = ({
  analyticId,
  onChange,
  ...props
}: TrackedSearchProps) => {
  const handleChange = (value: string) => {
    if (analyticId) {
      if (value === "") {
        // Track when search is cleared
        trackEventPendo(createUIAnalyticsEvent.search.cleared(analyticId));
      } else {
        // Track when user types in search
        trackEventPendo(createUIAnalyticsEvent.search.typed(analyticId, value));
      }
    }
    onChange?.(value);
  };

  return <Search {...props} onChange={handleChange} />;
};
